import React from "react";

export const TAGLINE = "Seamless rides. Fresh deliveries.";

export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <img
      src="/brand-logo.png"
      alt="KohimaTaxi &amp; Delivery"
      className={`inline-block shrink-0 rounded-[26%] object-contain shadow-sm ring-1 ring-black/5 ${className}`}
      aria-hidden="true"
    />
  );
}

export function BrandLockup({ light = false, compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      {!compact && (
        <span className="leading-tight">
          <span className={`block text-[15px] font-bold tracking-tight ${light ? "text-white" : "text-ink"}`}>KohimaTaxi &amp; Delivery</span>
          <span className={`block text-[11px] ${light ? "text-white/70" : "text-ink-muted"}`}>{TAGLINE}</span>
        </span>
      )}
    </span>
  );
}
